import { render, staticRenderFns } from "./FSelect.vue?vue&type=template&id=bb8a212c&scoped=true&"
import script from "./FSelect.vue?vue&type=script&lang=js&"
export * from "./FSelect.vue?vue&type=script&lang=js&"
import style0 from "./FSelect.vue?vue&type=style&index=0&id=bb8a212c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8a212c",
  null
  
)

export default component.exports